//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class Sticker extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'Sticker';
  }
}
Sticker.initClass();

export { Sticker };
